<template>
  <span>{{ params?.text }}</span>
</template>

<script setup lang="ts">
// AG Grid mounts this as a cell renderer and passes everything through `params`.
defineProps<{ params?: { text?: string } }>();
</script>
